import { gql } from '@apollo/client'

/**
 * Get a workspace's apps. (Currently backend only returns enabled)
 */
export const GET_APPS = gql`
  query {
    workspaceApps {
      workspaceID
      appType
      enabledByUserID
      enabled
      externalWorkspaceID
      appMetadata {
        carriers {
          brokerMC
          dotNumber
          integrationConfigurationID
          mcNumber
          provider
          scacCode
          truckerToolsOverride {
            brokerMC
            dotNumber
            mcNumber
            scacCode
          }
        }
        companyID
        encodedCredentialsValidated
        rateConfirmationEmail
        allowedEmailAddresses
        customers {
          customerID
          customerNameInChaine
          customerIDInChaine
          integrationConfigurationID
          customerSequenceNumber
        }
        mcLeodInstanceURL
        mcLeodVersion
        mcLeodServerTimezone
        onboardingURL
        tmsURL
      }
      appCredentials {
        apiKey
        chaineAPIToken
        password
        username
      }
    }
  }
`
